export default __webpack_public_path__ + "static/Montserrat-Light-02afb26fe72fcc05298817491c044b7b.ttf";